/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useQuery } from "@tanstack/react-query";
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { ErrorType } from "../../apix-handler";
import type {
  DiscussionsByExternalIdGetV2Params,
  DiscussionsContract,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const discussionsByExternalIdGetV2 = (
  externalId: string,
  params?: DiscussionsByExternalIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<DiscussionsContract>(
    {
      url: `/apix/v2/Discussions/${externalId}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getDiscussionsByExternalIdGetV2QueryKey = (
  externalId?: string,
  params?: DiscussionsByExternalIdGetV2Params,
) => {
  return [
    `/apix/v2/Discussions/${externalId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDiscussionsByExternalIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof discussionsByExternalIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  externalId: string,
  params?: DiscussionsByExternalIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof discussionsByExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDiscussionsByExternalIdGetV2QueryKey(externalId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof discussionsByExternalIdGetV2>>
  > = ({ signal }) =>
    discussionsByExternalIdGetV2(externalId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!externalId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof discussionsByExternalIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DiscussionsByExternalIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof discussionsByExternalIdGetV2>>
>;
export type DiscussionsByExternalIdGetV2QueryError = ErrorType<unknown>;

export function useDiscussionsByExternalIdGetV2<
  TData = Awaited<ReturnType<typeof discussionsByExternalIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  externalId: string,
  params?: DiscussionsByExternalIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof discussionsByExternalIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDiscussionsByExternalIdGetV2QueryOptions(
    externalId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
